"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.table = void 0;
var table = {
  colors: {
    light: {
      borderedBorderColor: function borderedBorderColor(get) {
        return get('colorScheme', 'lightDarker');
      },
      stripedBackgroundColor: function stripedBackgroundColor(get) {
        return get('colorScheme', 'dark10Alpha');
      },
      backgroundColorHoverFocus: function backgroundColorHoverFocus(get) {
        return get('colorScheme', 'dark25Alpha');
      },
      darkColor: function darkColor(get) {
        return get('colorScheme', 'white');
      },
      darkBackgroundColor: function darkBackgroundColor(get) {
        return get('colorScheme', 'darker');
      },
      darkBorderColor: function darkBorderColor(get) {
        return get('colorScheme', 'darkerDarker');
      },
      theadDarkColor: function theadDarkColor(get) {
        return get('colorScheme', 'white');
      },
      theadDarkBackgroundColor: function theadDarkBackgroundColor(get) {
        return get('colorScheme', 'darker');
      },
      theadDarkBorderColor: function theadDarkBorderColor(get) {
        return get('colorScheme', 'darkerDarker');
      },
      stripedDarkBackgroundColor: function stripedDarkBackgroundColor(get) {
        return get('colorScheme', 'white10Alpha');
      },
      darkBackgroundColorHoverFocus: function darkBackgroundColorHoverFocus(get) {
        return get('colorScheme', 'white10Alpha');
      },
      theadLightColor: function theadLightColor(get) {
        return get('colorScheme', 'dark');
      },
      theadLightBackgroundColor: function theadLightBackgroundColor(get) {
        return get('colorScheme', 'darkLight');
      },
      theadLightBorderColor: function theadLightBorderColor(get) {
        return get('colorScheme', 'darkLight');
      },
      borderColor: function borderColor(get) {
        return get('colorScheme', 'darkLight');
      },
      backgroundColor: function backgroundColor(get) {
        return get('colorScheme', 'white');
      }
    },
    dark: function dark(get) {
      return get('table', 'colors', 'light');
    },
    default: function _default(get) {
      return get('table', 'colors', 'light');
    },
    padding: {
      sm: '0.3rem'
    }
  },
  border: function border(get) {
    return get('globals', 'border');
  }
};
exports.table = table;


//////////////////
// WEBPACK FOOTER
// ./node_modules/styled-config/lib/theme/table.js
// module id = 1189
// module chunks = 0